import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderSlot as _renderSlot, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "col" }
const _hoisted_2 = { class: "col-3" }
const _hoisted_3 = { class: "col-1" }
const _hoisted_4 = { class: "q-px-sm" }

import { Expenses } from '../types/expenses'
import { onBeforeMount, ref, watch } from 'vue'
import { useExpenses } from '../store/useExpenses'
import { useI18n } from 'vue-i18n'

export default /*#__PURE__*/_defineComponent({
  __name: 'FormExpense',
  props: {
    expenses: {},
    date: { default: () => new Date() }
  },
  setup(__props: any) {

const props = __props

//translations
const { t } = useI18n({ useScope: 'global' })
const formLabel = (key: string) => t(`form.${key}`)

const expensesEdits = ref<(typeof props)['expenses']>([])
onBeforeMount(() => {
  props.expenses.forEach((expense) => expensesEdits.value.push({ ...expense }))
  expensesEdits.value.push({
    id: 0,
    description: null,
    amount: null,
    currency: 'string',
    date: props.date,
  })
})
watch(props, () => {
  expensesEdits.value = []
  props.expenses.forEach((expense) => expensesEdits.value.push({ ...expense }))
  expensesEdits.value.push({
    id: 0,
    description: null,
    amount: null,
    currency: 'string',
    date: props.date,
  })
})

const removeExpense = (index: number) => {
  expensesEdits.value.splice(index, 1)
}
const add = () => {
  expensesEdits.value.push({
    id: expensesEdits.value.length,
    description: null,
    amount: null,
    currency: 'string',
    date: props.date,
  })
}
const save = () => {
  const { saveExpensesByDate } = useExpenses()
  const toSave = expensesEdits.value.filter((expense) => {
    return expense.amount !== null && expense.description !== null
  })
  saveExpensesByDate(
    toSave.map((expense) => {
      return { ...expense, amount: Number(expense.amount) }
    }),
    props.date
  )
}

/**check if key is a number */
const isALetter = (text: string): boolean => {
  //things like backspace etc allowed
  if (text.length > 1) return false
  const numb = new RegExp(/[^a-zA-Z]/)
  return !numb.test(String(text))
}
/**Logic to prevent input of non digits */
const captureNumber = (e: KeyboardEvent) => {
  if (isALetter(e.key)) {
    e.preventDefault()
  }
}

return (_ctx: any,_cache: any) => {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_card_section, { class: "q-pt-none q-col-gutter-y-md" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(expensesEdits.value, (expense, expenseIndex) => {
          return (_openBlock(), _createElementBlock("div", {
            key: expense.id,
            class: "row items-center q-col-gutter-x-sm"
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_q_input, {
                filled: "",
                color: "accent",
                modelValue: expensesEdits.value[expenseIndex].description,
                "onUpdate:modelValue": ($event: any) => ((expensesEdits.value[expenseIndex].description) = $event),
                label: formLabel('description')
              }, null, 8, ["modelValue", "onUpdate:modelValue", "label"])
            ]),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_q_input, {
                filled: "",
                color: "accent",
                modelValue: expensesEdits.value[expenseIndex].amount,
                "onUpdate:modelValue": ($event: any) => ((expensesEdits.value[expenseIndex].amount) = $event),
                label: formLabel('amount'),
                type: "number",
                prefix: "$",
                onKeydown: captureNumber
              }, null, 8, ["modelValue", "onUpdate:modelValue", "label"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              (expenseIndex + 1 < expensesEdits.value.length)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 0,
                    onClick: ($event: any) => (removeExpense(expenseIndex)),
                    round: "",
                    color: "accent",
                    icon: "remove",
                    size: "sm"
                  }, null, 8, ["onClick"]))
                : (_openBlock(), _createBlock(_component_q_btn, {
                    key: 1,
                    onClick: add,
                    round: "",
                    color: "accent",
                    icon: "add",
                    size: "sm"
                  }))
            ])
          ]))
        }), 128))
      ]),
      _: 1
    }),
    _renderSlot(_ctx.$slots, "actions", { expensesEdits: expensesEdits.value }, () => [
      _createVNode(_component_q_card_actions, {
        align: "right",
        class: "text-primary"
      }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_q_btn, {
            rounded: "",
            flat: "",
            label: formLabel('close')
          }, null, 8, ["label"]), [
            [_directive_close_popup]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
            rounded: "",
            color: "primary",
            onClick: save
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_4, _toDisplayString(formLabel('save')), 1)
            ]),
            _: 1
          })), [
            [_directive_close_popup]
          ])
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})